import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CSSModules from "react-css-modules";
import Loading from "components/loading/Loading";
import TopBar from "./TopBar";
import Footer from "./Footer";
import styles from "./root.scss";
import MobileBanner from "components/banners/MobileBanner";
import * as cardActions from "../card/redux";

@connect(
  state => ({
    loaded: state.reduxAsyncConnect.loaded,
    isAuthenticated: state.auth.isAuthenticated
  }),
  dispatch => ({
    cardReset: () => dispatch(cardActions.reset()),
    cardFetch: () => dispatch(cardActions.fetch(dispatch))
  })
)
@CSSModules(styles)
class Root extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    loaded: PropTypes.bool.isRequired,
    cardReset: PropTypes.func,
    cardFetch: PropTypes.func
  };

  constructor(props) {
    super(...arguments);
    props.cardReset();
    props.cardFetch();
  }

  renderDownloadAppBanner(){
    const userId = this.props.authData && this.props.authData.user && this.props.authData.user.id || null;
    return (
      <MobileBanner
        currentUserId={userId}
        bannerStyle="bright"
        bannerMessage="app.banner.message"
        downloadBtnLabel="app.banner.btnLabel"/>
    );
  }

  render() {
    return (
      <div styleName="root">
        {this.renderDownloadAppBanner()}
        {!this.props.loaded ? <Loading /> : ""}
        <TopBar />
        <main styleName="content">{this.props.children}</main>
        <Footer />
      </div>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/root/Root.js